import * as React from 'react';
import { StyledChildren, StyledField, StyledLabel } from './styled';

type Props = {
  label?: React.ReactNode;
  children?: React.ReactNode;
};

export const Field: React.FC<Props> = ({ label, children }) => (
  <StyledField>
    <StyledLabel>{label}</StyledLabel>
    <StyledChildren>{children}</StyledChildren>
  </StyledField>
);
